export default __webpack_public_path__ + "_/_/libs/common/src/assets/img/computer_2022.png";